import { FaTimes } from "react-icons/fa";

const Tag = ({ text, selected, removeIcon }) => {
	let classes =
		"flex-none inline-flex py-1 px-2 rounded-2xl text-xs font-semibold border border-theme subtle-shadow items-center";

	if (selected) {
		classes += " background-theme text-theme";
	} else {
		classes += " bg-white text-theme-alt";
	}

	return (
		<span className={classes}>
			{text}
			{removeIcon && <FaTimes className="ml-2 hover:text-gray-200" />}
		</span>
	);
};

export default Tag;
